import React, { Fragment } from "react";

import { Mutation as ApolloMutation } from "react-apollo";

import { translate } from "react-i18next";
import { compose } from "recompose";

import AuthenticationErrors from "./AuthenticationErrors";

import { getErrors } from "./errors";

class Mutation extends React.Component {
  state = {
    index: 0,
  };

  // This makes sure any authentication errors are displayed again
  incrementIndex = result => {
    this.setState(({ index }) => ({ index: index + 1 }));
    return result;
  };

  render() {
    const { t } = this.props;

    return (
      <ApolloMutation {...this.props}>
        {(mutationFn, result) => {
          const {
            errorMessages,
            authenticationErrors,
            errorMessageKeys,
          } = getErrors(result.error, t);

          return (
            <Fragment>
              {/* {authenticationErrors ? (
                <AuthenticationErrors
                  errors={authenticationErrors}
                  key={this.state.index}
                />
              ) : null} */}
              {this.props.children(compose(this.incrementIndex, mutationFn), {
                ...result,
                errorMessages,
                errorMessageKeys,
              })}
            </Fragment>
          );
        }}
      </ApolloMutation>
    );
  }
}

export default translate("translations")(Mutation);



// WEBPACK FOOTER //
// ./src/graphql/Mutation.js